export const updateElementContentById = (id: string, innerText: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.innerText = innerText;
  }
};
